import type { AdaptiveLevel, AdaptiveMode } from "@/types"

export const ADAPTIVE_LEVELS: readonly AdaptiveLevel[] = [1, 2, 3, 4, 5]
export const ADAPTIVE_MODES: readonly AdaptiveMode[] = ["off", "shadow", "automatic"]
export const ADAPTIVE_PAGE_SIZES = [25, 50, 100] as const
export const DEFAULT_ADAPTIVE_PAGE_SIZE = 50

export const isAdaptiveLevel = (value: number): value is AdaptiveLevel =>
  Number.isInteger(value) && value >= 1 && value <= 5

export const adjacentAdaptiveLevels = (current: AdaptiveLevel): AdaptiveLevel[] =>
  ADAPTIVE_LEVELS.filter((level) => Math.abs(level - current) === 1)

/**
 * `?adaptativo=1` on a classroom roster opens its adaptive-levels dialog.
 * Here rather than in `features/students/` because other features link INTO
 * it — Home's "niveles por revisar" row first (the `ALL_CLASSROOMS`
 * reasoning, `constants/classroomScope.ts`). Spanish, accent-free
 * (`url-conventions.md` §4).
 */
export const ADAPTIVE_DIALOG_PARAM = "adaptativo"
export const ADAPTIVE_DIALOG_OPEN = "1"

export const classroomAdaptiveHref = (classroomId: string) =>
  `/salones/${classroomId}/alumnos?${ADAPTIVE_DIALOG_PARAM}=${ADAPTIVE_DIALOG_OPEN}`
